import React from 'react'
import PropTypes from 'prop-types'
import { Provider, inject, observer } from 'mobx-react'
import Store from './stores/Store.js'
import DesignTemplateThumbnail from './components/DesignTemplateThumbnail'
import CategoryViewer from './components/CategoryViewer'
import TagViewer from './components/TagViewer'
import LayoutViewer from './components/LayoutViewer'

// Leaving this in here for future revisions
const showCategoryViewer = false


@inject("widgetStore")
@observer
export default class DesignTemplateList extends React.Component {
  static propTypes = {
    widgetStore: PropTypes.object.isRequired,
    showBookNowButton: PropTypes.bool,
    bookNowButtonText: PropTypes.string,
    showTagViewer: PropTypes.bool,
    showLayoutViewer: PropTypes.bool,
    categoryId: PropTypes.number,
    buttonBackgroundColor: PropTypes.string,
    buttonForegroundColor: PropTypes.string,
    textColor: PropTypes.string,
  }

  static defaultProps = {
    showBookNowButton: true,
    bookNowButtonText: "Book Now",
    showTagViewer: true,
    showLayoutViewer: true
  }

  designTemplateStore = new Store({ widgetStore: this.props.widgetStore })

  componentDidMount() {
    const { categoryId } = this.props

    this.designTemplateStore.setup(categoryId)
  }

  render() {
    const { designTemplateStore } = this
    const { showBookNowButton, bookNowButtonText, showTagViewer, showLayoutViewer, buttonBackgroundColor, buttonForegroundColor, textColor } = this.props
    const { ready, loading, activeDesignTemplates } = designTemplateStore

    if(!ready) {
      return null
    }
    else if(loading) {
      return (
        <div>Loading...</div>
      )
    }
    else {
      return (
        <Provider store={designTemplateStore}>
          <div style={styles.wrapper}>
            { (showCategoryViewer && designTemplateStore.categories.length > 0) &&
              <div style={styles.categoryContainer}>
                <CategoryViewer
                  buttonBackgroundColor={buttonBackgroundColor}
                  buttonForegroundColor={buttonForegroundColor}
                  textColor={textColor}
                />
              </div>
            }
            { (showTagViewer && designTemplateStore.designCategoryTags.length > 0) &&
              <div style={styles.tagContainer}>
                <TagViewer
                  buttonBackgroundColor={buttonBackgroundColor}
                  buttonForegroundColor={buttonForegroundColor}
                  textColor={textColor}
                />
              </div>
            }
            { (showLayoutViewer && designTemplateStore.designCategoryLayouts.length > 0) &&
              <div style={styles.layoutContainer}>
                <LayoutViewer
                  buttonBackgroundColor={buttonBackgroundColor}
                  buttonForegroundColor={buttonForegroundColor}
                  textColor={textColor}
                />
              </div>
            }
            <div style={styles.designTemplateContainer}>
              { activeDesignTemplates.map(designTemplate =>
                <DesignTemplateThumbnail
                  key={designTemplate.id}
                  showBookNowButton={showBookNowButton}
                  bookNowButtonText={bookNowButtonText}
                  designTemplate={designTemplate}
                  style={styles.designTemplate}
                  buttonBackgroundColor={buttonBackgroundColor}
                  buttonForegroundColor={buttonForegroundColor}
                  textColor={textColor}
                />
              )}
              <div style={styles.designTemplate} />
            </div>
          </div>
        </Provider>
      )
    }
  }
}

const styles = {
  wrapper: {
    maxWidth: "100%"
  },
  categoryContainer: {
  },
  designTemplateContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center"
  },
  designTemplate: {
    width: 300,
    boxSizing: "border-box",
    padding: 10
  }
}
